import { getUrlParts } from "app/urlUtility";

export interface Resource {
  links?: HateoasElement[];
}

export interface ResourceList<T extends Resource> extends Resource
{
  resources: T[];
}

export interface ApiCall {
  status: ApiCallStatus;
  error?: string
}

export interface ApiCallState<T = any> extends ApiCall {
  value: T | null;
}

export interface ApiResourceState<T extends Resource> extends ApiCallState<T> {
}

export enum ApiCallStatus {
  Idle = 'IDLE',
  Loading = 'LOADING',
  Failed = 'FAILED',
  Succeeded = 'SUCEEDED'
}


export interface HateoasElement {
  rel: string;
  href: string;
  method: MethodType;
}

export enum MethodType {
  DELETE = 'DELETE',
  GET = 'GET', 
  POST = 'POST',
  PUT = 'PUT',
  OPTIONS = 'OPTIONS'
}

export enum PageDirection {
  Next = 'next',
  Previous = 'prev'
}

export function getHateoasElement(
  resource: Resource | null,
  rel: string,
  methodType: MethodType = MethodType.GET): HateoasElement | null {
  if (resource) {
    for (const hateoasElement of resource.links!) {
      if (hateoasElement.rel.toUpperCase() === rel.toUpperCase()
        && hateoasElement.method === methodType) {
        return hateoasElement;
      }
    }
  }
  return null;
}

export function hasHateoasElement(resource: Resource | null, rel: string) {
  return !!getHateoasElement(resource, rel);
}

export function getSelfHateoasElement(resource: Resource) {
  return getHateoasElement(resource, 'self')!;
}

export function getSelfRelUrlForWindowNavigation(resource: Resource) {
  const selfHateoasElement = getSelfHateoasElement(resource);
  const urlParts = getUrlParts(selfHateoasElement.href);
  return urlParts.pathname.substring(4);
}

export function isLoadingNetworkCall(apiCall: ApiCall) {
  return apiCall.status === ApiCallStatus.Idle
    || apiCall.status === ApiCallStatus.Loading;
}

export function isNetworkCallCompleted(apiCall: ApiCall) {
  return apiCall.status === ApiCallStatus.Failed
    || apiCall.status === ApiCallStatus.Succeeded;
}

export function shouldMakeNetworkCall(apiCall: ApiCall) {
  return apiCall.status === ApiCallStatus.Idle;
}